import { BasicThumbnailLightbox } from "@components/thumbnailLightbox/basicThumbnailLightbox";
import { SamplingLabelThirdPartyInfo, SamplingThirdPartyInfo, ThirdPartyType } from "@models/graphql";
import * as React from "react";
import * as moment from "moment";
import { ThirdPartyInfoStyle, ThirdPartyInfoTypeTitle } from "./thirdPartyInfoStyle";
import { FormattedMessage } from "react-intl";

interface ThirdPartyInfoDisplayerProps {
    item: SamplingThirdPartyInfo
}

export const ThirdPartyInfoDisplayer: React.FC<ThirdPartyInfoDisplayerProps> = ({ item }) => {
    switch(item.type) {
        case ThirdPartyType.Label:
            return (
                <ThirdPartyInfoStyle>
                    <ThirdPartyInfoTypeTitle><FormattedMessage id="thirdPartyInfoType.LABEL"/></ThirdPartyInfoTypeTitle>
                    <div><FormattedMessage id="samplingLabelThirdPartyInfo.reference"/> {(item as SamplingLabelThirdPartyInfo).reference}</div>
                    <div><FormattedMessage id="samplingLabelThirdPartyInfo.brand"/> {(item as SamplingLabelThirdPartyInfo).brand}</div>
                    <div><FormattedMessage id="samplingLabelThirdPartyInfo.model"/> {(item as SamplingLabelThirdPartyInfo).model}</div>
                    <div><FormattedMessage id="samplingLabelThirdPartyInfo.detection"/> {(item as SamplingLabelThirdPartyInfo).detection}</div>
                    <div><FormattedMessage id="samplingLabelThirdPartyInfo.recordedAt"/> {moment((item as SamplingLabelThirdPartyInfo).recordedAt).format("DD/MM/YYYY HH:mm")}</div>                    
                    <BasicThumbnailLightbox images={[{url: (item as SamplingLabelThirdPartyInfo).photoUrl, thumbnailUrl: (item as SamplingLabelThirdPartyInfo).photoUrl}]} />
                </ThirdPartyInfoStyle>
            );
            default:
                return null;
    }
};